import styled from '@themes/theme'

export const TelegramSettingContainer = styled.div`
  max-height: 488px;
  overflow-y: auto;
  
  &:empty {
    height: 270px;
  }
  
  img {
    width: 100%;
  }
`
